import { Link } from 'wouter';

export const Footer = () => (
    <footer className="border-t border-border/40 py-10">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
                <div className="w-7 h-7 rounded-md bg-primary flex items-center justify-center">
                    <span className="text-primary-foreground font-bold text-sm leading-none">H</span>
                </div>
                <div>
                    <span className="font-semibold text-sm">Handoff</span>
                    <span className="text-muted-foreground text-xs block">The handover, done properly.</span>
                </div>
            </div>
            <div className="flex items-center gap-5 text-xs text-muted-foreground">
                <Link href="/pricing" className="hover:text-foreground">
                    Pricing
                </Link>
                <Link href="/calculator/advanced" className="hover:text-foreground">
                    Business case
                </Link>
                <span>&copy; {new Date().getFullYear()} Handoff Ltd.</span>
            </div>
        </div>
    </footer>
);
